export const FUNCTIONS = [
  {
    label: "Comparative",
    comparative: true,
  },
  {
    label: "Cumulative",
    comparative: false,
  },
];

interface Interval {
  name: string;
  firstKey: string;
  secondKey: string | undefined;
}

interface Interval {
  name: string;
  firstKey: string;
  secondKey: string | undefined;
}

export const INTERVAL: Interval[] = [
  { name: "Time Slot", firstKey: "slot", secondKey: "date" },
  { name: "Date", firstKey: "date", secondKey: undefined },
  { name: "Month", firstKey: "month", secondKey: undefined },
  { name: "Station", firstKey: "station", secondKey: undefined },
  { name: "Area", firstKey: "sector", secondKey: undefined },
  { name: "State", firstKey: "state", secondKey: undefined },
  { name: "Source", firstKey: "source", secondKey: undefined },
];

export function getRajIntervals(): Interval[] {
  return INTERVAL.slice(0, 3);
}

export function getShowBrush(chartData: any[], selectedKey: Interval): boolean {
  if (selectedKey.firstKey === "slot") {
    return chartData.length > 96 * 1;
  } else {
    return chartData.length > 7;
  }
}

export function getBrushIndex(selectedKey: Interval): {
  startIndex: number;
  endIndex: number;
} {
  if (selectedKey.firstKey === "slot") {
    return { startIndex: 0, endIndex: 96 * 1 };
  } else {
    return { startIndex: 0, endIndex: 7 };
  }
}

export const RAJ_UNITS = ["MW", "MWh"];

export const handleUnitChange = (
  selectedUnit: string,
  selectedKey: Interval,
  setSelectedUnit: any
) => {
  setSelectedUnit(selectedUnit);
};

export const handleKeyChange = (
  index: number,
  setSelectedKey: any,
  setSelectedUnit: any
) => {
  setSelectedKey(INTERVAL[index]);
};

export const DEFAULT_YEARS = [
  { value: "2022-01-01,2022-12-31", label: "2022" },
  { value: "2023-01-01,2023-12-31", label: "2023" },
  { value: "2024-01-01,2024-12-31", label: "2024" },
  { value: "2025-01-01,2025-12-31", label: "2025" },
].reverse();

// Quarters array
export const DEFAULT_QUARTERS = [
  // 2022
  { value: "2022-01-01,2022-03-31", label: "Q1-2022" },
  { value: "2022-04-01,2022-06-30", label: "Q2-2022" },
  { value: "2022-07-01,2022-09-30", label: "Q3-2022" },
  { value: "2022-10-01,2022-12-31", label: "Q4-2022" },
  // 2023
  { value: "2023-01-01,2023-03-31", label: "Q1-2023" },
  { value: "2023-04-01,2023-06-30", label: "Q2-2023" },
  { value: "2023-07-01,2023-09-30", label: "Q3-2023" },
  { value: "2023-10-01,2023-12-31", label: "Q4-2023" },
  // 2024
  { value: "2024-01-01,2024-03-31", label: "Q1-2024" },
  { value: "2024-04-01,2024-06-30", label: "Q2-2024" },
  { value: "2024-07-01,2024-09-30", label: "Q3-2024" },
  { value: "2024-10-01,2024-12-31", label: "Q4-2024" },
  // 2025
  { value: "2025-01-01,2025-03-31", label: "Q1-2025" },
  { value: "2025-04-01,2025-06-30", label: "Q2-2025" },
  { value: "2025-07-01,2025-09-30", label: "Q3-2025" },
  { value: "2025-10-01,2025-12-31", label: "Q4-2025" },
].reverse();

// Financial Years array (Apr-Mar)
export const DEFAULT_FINANCIAL_YEARS = [
  { value: "2021-04-01,2022-03-31", label: "FY 2021-22" },
  { value: "2022-04-01,2023-03-31", label: "FY 2022-23" },
  { value: "2023-04-01,2024-03-31", label: "FY 2023-24" },
  { value: "2024-04-01,2025-03-31", label: "FY 2024-25" },
  { value: "2025-04-01,2026-03-31", label: "FY 2025-26" },
].reverse();

export const DEFAULT_DATES = [
  { value: "2022-01-01,2022-01-31", label: "JAN-22" },
  { value: "2022-02-01,2022-02-28", label: "FEB-22" },
  { value: "2022-03-01,2022-03-31", label: "MAR-22" },
  { value: "2022-04-01,2022-04-30", label: "APR-22" },
  { value: "2022-05-01,2022-05-31", label: "MAY-22" },
  { value: "2022-06-01,2022-06-30", label: "JUN-22" },
  { value: "2022-07-01,2022-07-31", label: "JUL-22" },
  { value: "2022-08-01,2022-08-31", label: "AUG-22" },
  { value: "2022-09-01,2022-09-30", label: "SEP-22" },
  { value: "2022-10-01,2022-10-31", label: "OCT-22" },
  { value: "2022-11-01,2022-11-30", label: "NOV-22" },
  { value: "2022-12-01,2022-12-31", label: "DEC-22" },
  { value: "2023-01-01,2023-01-31", label: "JAN-23" },
  { value: "2023-02-01,2023-02-28", label: "FEB-23" },
  { value: "2023-03-01,2023-03-31", label: "MAR-23" },
  { value: "2023-04-01,2023-04-30", label: "APR-23" },
  { value: "2023-05-01,2023-05-31", label: "MAY-23" },
  { value: "2023-06-01,2023-06-30", label: "JUN-23" },
  { value: "2023-07-01,2023-07-31", label: "JUL-23" },
  { value: "2023-08-01,2023-08-31", label: "AUG-23" },
  { value: "2023-09-01,2023-09-30", label: "SEP-23" },
  { value: "2023-10-01,2023-10-31", label: "OCT-23" },
  { value: "2023-11-01,2023-11-30", label: "NOV-23" },
  { value: "2023-12-01,2023-12-31", label: "DEC-23" },
  { value: "2024-01-01,2024-01-31", label: "JAN-24" },
  { value: "2024-02-01,2024-02-29", label: "FEB-24" }, // Leap year
  { value: "2024-03-01,2024-03-31", label: "MAR-24" },
  { value: "2024-04-01,2024-04-30", label: "APR-24" },
  { value: "2024-05-01,2024-05-31", label: "MAY-24" },
  { value: "2024-06-01,2024-06-30", label: "JUN-24" },
  { value: "2024-07-01,2024-07-31", label: "JUL-24" },
  { value: "2024-08-01,2024-08-31", label: "AUG-24" },
  { value: "2024-09-01,2024-09-30", label: "SEP-24" },
  { value: "2024-10-01,2024-10-31", label: "OCT-24" },
  { value: "2024-11-01,2024-11-30", label: "NOV-24" },
  { value: "2024-12-01,2024-12-31", label: "DEC-24" },
  { value: "2025-01-01,2025-01-31", label: "JAN-25" },
  { value: "2025-02-01,2025-02-28", label: "FEB-25" },
  { value: "2025-03-01,2025-03-31", label: "MAR-25" },
  { value: "2025-04-01,2025-04-30", label: "APR-25" },
  { value: "2025-05-01,2025-05-31", label: "MAY-25" },
  { value: "2025-06-01,2025-06-30", label: "JUN-25" },
  { value: "2025-07-01,2025-07-31", label: "JUL-25" },
  { value: "2025-08-01,2025-08-31", label: "AUG-25" },
  { value: "2025-09-01,2025-09-30", label: "SEP-25" },
  { value: "2025-10-01,2025-10-31", label: "OCT-25" },
  { value: "2025-11-01,2025-11-30", label: "NOV-25" },
  { value: "2025-12-01,2025-12-31", label: "DEC-25" },
].reverse();
